<ng-container *ngIf="messages">
  <span *ngFor="let message of messages" class="alert alert-{{ message['type'] }} alert-dismissible float-end" role="alert">
    <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close" (click)="dismissMessage(message)">
      <span aria-hidden="true">&times;</span>
    </button>
    <strong>{{ message['message'] }}</strong>
  </span>
</ng-container>
